import { Injectable } from '@angular/core';
import { gql, Mutation } from 'apollo-angular';

import { Mutation as RootMutation } from 'graphql/models/generated';
import { PRODUCT_LINE_PRICING_FRAGMENT } from 'graphql/fragments/product-line-pricing';
import { CUSTOM_LINE_PRICING_FRAGMENT } from 'graphql/fragments/custom-line-pricing';
import { QUOTE_PRICING_STATE_FRAGMENT } from 'graphql/fragments/quote-pricing-state';

export const ENSURE_PRICES_UPDATED_MUTATION = gql`
mutation ensurePricesUpdated(
  $documentVersion: DocumentVersionInput!,
  $lineId: String!,
  $withPricing: Boolean = true
  ) {
  quotes {
    ensurePricesUpdated(documentVersion: $documentVersion) {
      documentId
      revision
      createdByType
      locked
      line(id: $lineId) {
        ...ProductLinePricingFragment @include(if: $withPricing)
        ...CustomLinePricingFragment @include(if: $withPricing)
      }
      ...QuotePricingStateFragment @skip(if: $withPricing)
    }
  }
}
${PRODUCT_LINE_PRICING_FRAGMENT}
${CUSTOM_LINE_PRICING_FRAGMENT}
${QUOTE_PRICING_STATE_FRAGMENT}
`;

@Injectable({
  providedIn: 'root'
})
export class EnsurePricesUpdatedMutation extends Mutation<RootMutation> {
  document = ENSURE_PRICES_UPDATED_MUTATION;
}
